export const handleAbhaGenderFormat = (gender) => {
  const genderLowerCase = gender?.toLowerCase();
  let result = gender;
  if (genderLowerCase === "m") {
    result = "Male";
  } else if (genderLowerCase === "f") {
    result = "Female";
  }

  return result;
};
